import LegalPage from "@/pages/LegalPage";

export default function ReturnPolicy() {
  return (
    <LegalPage title="Return & Refund Policy" subtitle="Returns" testId="return-page">
      <p>We want you to love what you wear. If something isn't quite right, we'll help you make it right.</p>

      <h2>Eligibility</h2>
      <ul>
        <li>Return/exchange requests must be raised within 7 days of delivery.</li>
        <li>Products must be unused, unwashed, and returned with original tags and packaging.</li>
        <li>Items purchased on sale/discount are eligible for exchange only (not refund).</li>
      </ul>

      <h2>How to Request a Return</h2>
      <ol className="list-decimal pl-5 space-y-1">
        <li>WhatsApp us at +91 97299 27206 or email <a href="mailto:thefabrics37@gmail.com">thefabrics37@gmail.com</a> with your order ID and reason.</li>
        <li>Our team will guide you through pickup or self-ship instructions.</li>
        <li>Once we receive and inspect the item, we'll confirm the refund/exchange.</li>
      </ol>

      <h2>Refunds</h2>
      <ul>
        <li>Prepaid orders: refund credited to the original payment method within 5–7 business days.</li>
        <li>COD orders: refund via bank transfer or store credit.</li>
        <li>Shipping charges (if any) are non-refundable.</li>
      </ul>

      <h2>Damaged or Wrong Product</h2>
      <p>If you receive a damaged, defective, or wrong item, please contact us within 48 hours of delivery with photos. We'll arrange a free replacement at no extra cost.</p>

      <h2>Non-Returnable Items</h2>
      <ul>
        <li>Innerwear, socks, and personal-care items (for hygiene).</li>
        <li>Products marked "Final Sale".</li>
      </ul>
    </LegalPage>
  );
}
